import CollectionDataGrid, { DeleteButton } from '@/components/CollectionDataGrid'
import { pbUpsert, useCollection, usePaginatedCollection } from '@/pb'
import { arrayToObject, useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material'
import { useState } from 'react'

const blockUnblock = (deviceId, blocked) => () => {
    pb.collection('devices').update(deviceId, { blocked })
}

const BlockButton = ({ id, blocked }) => (
    <Button
        onClick={blockUnblock(id, !blocked)}
        variant={blocked ? 'contained' : 'text'}
        color={blocked ? 'error' : 'primary'}
    >
        {blocked ? 'Разблокировать' : 'Заблокировать'}
    </Button>
)

const Editor = ({ row, onClose }) => {
    const [deviceId, setDeviceId] = useInputState(row?.deviceId)
    const [roomId, setRoomId] = useInputState(row?.roomId || 'none')
    const [rooms, roomsLoaded] = useCollection('rooms')

    if (!roomsLoaded) return <LinearProgress />

    return <>
        <DialogTitle>Устройство</DialogTitle>
        <DialogContent className="editorForm">
            <TextField label={fields.deviceId.headerName} value={deviceId} onChange={setDeviceId} />

            <FormControl>
                <InputLabel id="roomId">{fields['expand.roomId'].headerName}</InputLabel>
                <Select
                    labelId="roomId"
                    value={roomId}
                    label={fields['expand.roomId'].headerName}
                    onChange={setRoomId}
                >
                    <MenuItem value="none"><em>Не выбрано</em></MenuItem>
                    {Object.entries(rooms).map(([id, { name }]) =>
                        <MenuItem value={id}>{name}</MenuItem>
                    )}
                </Select>
            </FormControl>

            

        </DialogContent>
        <DialogActions>
            <DeleteButton id={row?.id} collection="devices" onDelete={onClose} style={{ marginLeft: '1rem', marginRight: 'auto' }}/>
            <Button onClick={onClose}>Отмена</Button>
            <Button onClick={() => pbUpsert('devices', { id: row?.id, deviceId, roomId: roomId === 'none' ? '' : roomId }).then(onClose)} variant="contained">Сохранить</Button>
        </DialogActions>
    </>
}

const columns = [
    { field: 'deviceId', headerName: 'ID Устройства', width: 300 },
    {
        field: 'expand.roomId', headerName: 'Комната', width: 300, renderCell: ({ row }) => {
            const room = row?.expand?.roomId
            return <span>{room?.name || '—'}</span>
        },
    },
    {
        field: 'blocked', headerName: 'Блокировка', width: 200,
        renderCell: ({ id, value }) => <BlockButton id={id} blocked={value} />
    },
]
const fields = arrayToObject(columns, 'field')

export default function GymDevices({ title }) {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    })

    const {
        records: devices,
        totalItems,
        loaded,
    } = usePaginatedCollection('devices', {
        page: paginationModel.page + 1,
        perPage: paginationModel.pageSize,
        sort: '-created',
        expand: 'roomId'
    })

    return <>
        <CollectionDataGrid
            collectionName={title}
            collection={devices}
            columns={columns}
            loading={!loaded}
            editor={Editor}
            serverPagination={true}
            rowCount={totalItems}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
        />
    </>

}